import React, { useEffect, useState } from "react";
import { api, formatPrice } from "../../lib/api";
import { PageHead } from "../../components/admin/AdminBits";
import { Eye, ShoppingCart, Users, TrendingUp } from "lucide-react";

export default function AdminAnalytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then(({ data }) => setD(data)); }, []);
  if (!d) return <p className="text-charcoal/50">Зареждане...</p>;
  const max = Math.max(1, ...d.by_day.map((x) => x.visits));

  const cards = [
    { icon: Eye, t: "Посещения днес", v: d.visits_today },
    { icon: TrendingUp, t: "Посещения (7 дни)", v: d.visits_7d },
    { icon: ShoppingCart, t: "Поръчки", v: d.orders },
    { icon: Users, t: "Клиенти", v: d.customers },
  ];

  return (
    <div data-testid="admin-analytics">
      <PageHead title="Анализи" desc="Посещения на сайта и ключови показатели." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-6">
        {cards.map((c) => (
          <div key={c.t} className="bg-white border border-stone p-5"><c.icon size={20} className="text-gold mb-2" /><p className="font-serif text-3xl text-navy">{c.v}</p><p className="text-sm text-charcoal/55 mt-1">{c.t}</p></div>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="bg-white border border-stone p-6">
          <h2 className="font-serif text-xl text-navy mb-5">Посещения (последни 7 дни)</h2>
          <div className="flex items-end gap-2 h-44">
            {d.by_day.map((x) => (
              <div key={x.date} className="flex-1 flex flex-col items-center gap-1">
                <span className="text-xs text-charcoal/50">{x.visits}</span>
                <div className="w-full bg-gold" style={{ height: `${(x.visits / max) * 140 + 4}px` }} />
                <span className="text-[10px] text-charcoal/40">{x.date.slice(5)}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white border border-stone p-6">
          <h2 className="font-serif text-xl text-navy mb-4">Най-посещавани страници</h2>
          {d.top_pages.length === 0 ? <p className="text-charcoal/50 text-sm">Все още няма данни.</p> : d.top_pages.map((p) => (
            <div key={p.path} className="flex justify-between py-2 border-b border-stone text-sm"><span className="text-charcoal/70 truncate">{p.path}</span><span className="text-navy font-medium">{p.count}</span></div>
          ))}
          <div className="flex justify-between mt-4 pt-2"><span className="font-serif text-navy">Общо приходи</span><span className="font-serif text-navy">{formatPrice(d.revenue)}</span></div>
        </div>
      </div>
    </div>
  );
}
